import { getAPIPath, requestGooseAPI } from '../shared/request'
import type { APIOrderSearchClientDtoResponse } from '../types/api'
import { CLIENT_ORDER_SEARCH_PATH } from '../types/constants'
import type { TOrderSearchOptions } from '../types/general'

export const ClientOrderSearchService = {
  getData: (locationName: string, options: TOrderSearchOptions): Promise<APIOrderSearchClientDtoResponse> => {
    const includes = new Set(['invoices.location', 'invoices.period', 'primaryServiceType.serviceType'])
    options.includes?.forEach((include) => includes.add(include))

    return requestGooseAPI<APIOrderSearchClientDtoResponse>({
      url: getAPIPath(CLIENT_ORDER_SEARCH_PATH, { locationId: locationName }),
      method: 'GET',
      params: {
        ...options,
        includes: Array.from(includes),
      },
    })
  },
}
